import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IProps {
  count: number;
}

export const SelectedImagesCounter = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      {props.count > 0 && (
        <>
          {props.count} {props.count > 1 ? t('images_selected') : t('image_selected')}
        </>
      )}
    </div>
  );
});
